import { HttpResult, none, Unit } from 'widgets-for-react'
import { getCsrfToken } from '../utils/csrf'
import { prefixUrlWithLocale } from '../utils/url'

export async function setFlashMessage(
  type: 'alert' | 'notice',
  message: string
): Promise<HttpResult<Unit>> {
  const res = await fetch(prefixUrlWithLocale('/api/flash_messages'), {
    method: 'post',
    headers: [
      ['Content-Type', 'application/json'],
      ['Accept', 'application/json'],
      ['X-CSRF-Token', getCsrfToken()]
    ],
    body: JSON.stringify({
      type,
      message
    })
  })

  return { kind: 'result', value: none(), status: res.status }
}
